import { defineStore } from 'pinia';
import { useQuery } from '@tanstack/vue-query';
import { computed } from 'vue';
import personalInformationRepository from '@/repositories/personal_information_repository';
import accountRepository from '@/repositories/account_repository';

export const useUserProfileStore = defineStore(
    'userProfile',
    () => {
        // Query keys for consistency
        const USER_PROFILE_QUERY_KEY = ['userProfile'] as const;

        // Query for fetching user profile
        const userProfileQuery = useQuery({
            queryKey: USER_PROFILE_QUERY_KEY,
            queryFn: async () => {
                const response = await personalInformationRepository.profile.profileList();
                return response.data;
            },
            retry: false,
            refetchOnWindowFocus: false,
            refetchOnMount: false,
            refetchOnReconnect: false
        });

        const accountQuery = useQuery({
            queryKey: ['pictureUrl'],
            queryFn: async () => {
                const response = await accountRepository.user.pictureList();
                return response.data;
            },
            retry: false,
            refetchOnWindowFocus: false,
            refetchOnMount: false,
            refetchOnReconnect: false
        });

        return {
            // Query state - these provide reactive loading, error, and data states
            userProfile: userProfileQuery.data,
            isLoading: userProfileQuery.isPending,
            error: userProfileQuery.error,
            picture: accountQuery.data,
            pictureUrl: computed(() => accountQuery.data?.value?.url)
        };
    },
    {
        persist: true
    }
);
